import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import regionRepository from '@/api/repositories/regionRepository/RegionRepository.ts';

export const useRegions = () => {
  return useQuery({
    queryKey: ['regions'],
    queryFn: async () => {
      const { data, error } = await regionRepository.all({ order: { by: 'created_at', ascending: false } });
      if (error) throw new Error(error.message);
      return data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateRegion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { name: string }) => {
      const { data, error } = await regionRepository.create(payload);
      if (error) throw new Error(error.message);
      if (!data) throw new Error('Region was not returned after creation');
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['regions'] });
    },
  });
};
